import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import EmergencyButton from "@/components/EmergencyButton";

export default function Layout({ children }) {
  return (
    <div className="bg-[#FDFBF7] min-h-screen flex flex-col">
      <Navbar />
      <main className="pt-20 flex-1" data-testid="page-main">
        {children}
      </main>
      <Footer />
      <EmergencyButton />
    </div>
  );
}
